<template>
  <div>
    <div
      v-for="({ height, inRange }, index) in itemsPercentage"
      :key="`${index}_${height}`"
      class="inline-block w-[5%] px-3"
      :style="{
        height: `${height}%`,
      }"
    >
      <div
        class="rounded-xs size-full"
        :class="{
          'bg-static-default-hi': !inRange,
          'bg-static-info-hi': inRange,
        }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { between } from './helpers'

type GraphData = {
  range: number
  minSelected: number
  maxSelected: number
  items: number[]
}

const props = defineProps<GraphData>()

const maxCount = computed((): number => Math.max(...props.items))
const itemsPercentage = computed(() =>
  props.items.map((item, index) => {
    const min = props.range * index
    const max = props.range * (index + 1)

    return {
      inRange: between({
        min,
        max,
        minSelected: props.minSelected,
        maxSelected: props.maxSelected,
      }),
      height: Math.ceil((item / maxCount.value) * 100),
    }
  }),
)
</script>
